import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Pourcentage — symbole % dans pastille duotone */
export const PercentIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Pastille menthe */}
      <circle cx="12" cy="12" r="9.5" fill="var(--equiply-icon-bg)" fillOpacity="0.45" />
      <circle cx="12" cy="12" r="8.25" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Cercle haut */}
      <circle cx="9" cy="9" r="1.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Cercle bas */}
      <circle cx="15" cy="15" r="1.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Barre */}
      <path
        d="M16 8l-8 8"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round"
      />
    </svg>
  ),
);
PercentIcon.displayName = "PercentIcon";
